const attachEventOnScreenOrientationChange = (callback: () => void) => {
    if ('onorientationchange' in window) {
        window.addEventListener('orientationchange', callback);
    } else if ('orientation' in screen && 'addEventListener' in screen.orientation) {
        screen.orientation.addEventListener('change', callback);
    }
};

export default attachEventOnScreenOrientationChange;
